export default "__VITE_ASSET__CEqCgWCa__"